import React, { useEffect, useState } from 'react';
import { Button, Modal, notification } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import GenericTable from '../components/GenericTable';
import Spinner from '../components/Loader';
import { fetchProjectTeamsRequest, assignUsersToProjectRequest, removeProjectTeamsRequest } from '../redux-saga/actions/projectActions';
import { updateCurrentProjectId } from '../redux-saga/actions/customerActions';
import { fetchTeamsRequest } from '../redux-saga/actions/userActions';
import ProjectNavbar from '../components/ProjectNavbar';
import { useParams } from 'react-router-dom';
import MultiSelectUsers from '../components/AssigneeComponent';

const ProjectAssignees = () => {
  const dispatch = useDispatch();
  const { id } = useParams(); // Get project ID from URL params

  const projectTeams = useSelector((state) => state.project?.teams || []);
  const allUsers = useSelector((state) => state.user?.data || []);
  const loading = useSelector((state) => state.user?.loading);

  const [isAssigneeModalVisible, setIsAssigneeModalVisible] = useState(false);
  const [selectedAssignees, setSelectedAssignees] = useState([]);

  // Fetch project teams and all users when component mounts
  useEffect(() => {
    dispatch(updateCurrentProjectId(id));
    dispatch(fetchProjectTeamsRequest(id));
    dispatch(fetchTeamsRequest());
  }, [dispatch, id]);

  // Set initial selected assignees based on current project teams
  useEffect(() => {
    const teamIds = projectTeams.map((team) => team.id);
    setSelectedAssignees(teamIds);
  }, [projectTeams]);

  // Handle assigning users to project
  const handleAssignUsersSubmit = (assignees) => {
    dispatch(assignUsersToProjectRequest(id, assignees));
    notification.success({
      message: 'Success',
      description: 'Project assignees have been updated successfully.',
    });
    dispatch(fetchProjectTeamsRequest(id));
    setIsAssigneeModalVisible(false);
  };

  // Handle removing an individual assignee
  const handleRemoveAssignee = (userId) => {
Modal.confirm({
  title: 'Are you sure you want to remove this assignee?',
  content: 'This action cannot be undone.',
  okText: 'Yes',
  cancelText: 'No',
  onOk: () => {
    dispatch(removeProjectTeamsRequest(id,userId));
    dispatch(fetchProjectTeamsRequest(id));
  }
});  };

  const columnsConfig = [
    
    { title: 'Name', dataIndex: 'name', sortable: true },
    { title: 'Email ID', dataIndex: 'email', sortable: true },
    { title: 'Phone Number', dataIndex: 'mobile' },
    { title: 'Role', dataIndex: 'role', sortable: true },
    { title: 'Status', dataIndex: 'status', sortable: true },
    {
      title: 'Actions',
      dataIndex: 'actions',
      render: (_, record) => (
        <Button type="link" onClick={() => handleRemoveAssignee(record.id)}>
          Remove Assignee
        </Button>
      ),
    },
  ];

  return (
    <div style={{ display: 'flex' }}>
      <ProjectNavbar />
      <div style={{ width: '100%', padding: '10px' }}>
        <h1>Project Assignees</h1>
        <div style={{ display: 'flex', justifyContent: 'end', marginBottom: 16 }}>
          <Button onClick={() => setIsAssigneeModalVisible(true)}>Add Assignees</Button>
        </div>

        <div
          style={
            projectTeams.length > 12
              ? {
                  height: 'calc(100vh - 120px)',
                  overflowY: 'auto',
                  padding: '8px',
                }
              : {
                  padding: '8px',
                }
          }
        >
          {loading ? (
            <Spinner />
          ) : (
            <GenericTable
              data={projectTeams}
              columnsConfig={columnsConfig}
              searchKeys={['name', 'id']}
            />
          )}
        </div>

        {/* MultiSelectUsers Drawer for adding/removing assignees */}
        {isAssigneeModalVisible && (
          <MultiSelectUsers
            visible={isAssigneeModalVisible}
            predefinedAssignees={selectedAssignees}
            onClose={handleAssignUsersSubmit}
          />
        )}
      </div>
    </div>
  );
};

export default ProjectAssignees;
